/* Sura — Study Materials (<sura-study-files>) */
if (!customElements.get('sura-study-files')) {
  class SuraStudyFiles extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');
      if (!this.list) return; // logged-out gate view

      this.files = Array.from(this.querySelectorAll('[data-file]'));
      this.selects = Array.from(this.querySelectorAll('select[data-filter]'));
      this.keys = this.selects.map((s) => s.dataset.filter);
      this.emptyEl = this.querySelector('[data-empty]');
      this.countEl = this.querySelector('[data-count]');
      this.classLabel = this.querySelector('[data-class-label]');
      this.classLabelDefault = this.classLabel ? this.classLabel.textContent : '';

      // Newest uploads first
      this.files
        .sort((a, b) => (b.dataset.date || '').localeCompare(a.dataset.date || ''))
        .forEach((f) => this.list.appendChild(f));

      // Initial selections from the URL, e.g. ?class=10th+Std&medium=Tamil
      const params = new URLSearchParams(window.location.search);
      this.state = {};
      this.keys.forEach((k) => { this.state[k] = params.get(k) || ''; });

      if (!this.state.year && this.dataset.latestYear === 'true') {
        this.state.year = this.sorted('year', this.available('year'))[0] || '';
      }

      this.selects.forEach((select) => {
        select.addEventListener('change', () => {
          this.state[select.dataset.filter] = select.value;
          this.render(true);
        });
      });

      this.querySelector('[data-filters]')?.removeAttribute('hidden');
      this.render(false);
    }

    /* A file matches when it passes every active filter (optionally ignoring one) */
    matches(file, skipKey) {
      return this.keys.every((k) => k === skipKey || !this.state[k] || file.dataset[k] === this.state[k]);
    }

    /* Values of `key` that still have files, given the other selections */
    available(key) {
      const set = new Set();
      this.files.forEach((f) => {
        const v = f.dataset[key];
        if (v && this.matches(f, key)) set.add(v);
      });
      return Array.from(set);
    }

    sorted(key, values) {
      const lead = (s) => { const m = String(s).match(/\d+/); return m ? Number(m[0]) : Infinity; };
      if (key === 'year') return values.sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));
      if (key === 'class') return values.sort((a, b) => lead(a) - lead(b) || a.localeCompare(b));
      return values.sort((a, b) => a.localeCompare(b));
    }

    render(updateUrl) {
      // Drop selections that no longer have any files (e.g. subject after a class change)
      for (let pass = 0; pass < 2; pass += 1) {
        this.keys.forEach((k) => {
          if (this.state[k] && !this.available(k).includes(this.state[k])) this.state[k] = '';
        });
      }

      this.selects.forEach((select) => {
        const key = select.dataset.filter;
        const values = this.sorted(key, this.available(key));
        select.replaceChildren(new Option(select.dataset.all || 'All', ''));
        values.forEach((v) => select.add(new Option(v, v)));
        select.value = this.state[key];
      });

      let shown = 0;
      this.files.forEach((f) => {
        const ok = this.matches(f);
        f.hidden = !ok;
        if (ok) shown += 1;
      });

      if (this.emptyEl) this.emptyEl.hidden = shown > 0;
      if (this.countEl) this.countEl.textContent = `(${shown})`;

      if (this.classLabel) {
        const cls = this.state.class;
        const med = this.state.medium;
        this.classLabel.textContent = cls || med
          ? `${cls || this.classLabelDefault}${med ? ` (${med} Medium)` : ''}`
          : this.classLabelDefault;
      }

      if (updateUrl) {
        const url = new URL(window.location.href);
        this.keys.forEach((k) => {
          if (this.state[k]) url.searchParams.set(k, this.state[k]);
          else url.searchParams.delete(k);
        });
        window.history.replaceState({}, '', url);
      }
    }
  }

  customElements.define('sura-study-files', SuraStudyFiles);
}
